import { AppService } from "@root/services";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const useGlobal = () => {
  const { t } = useTranslation("common");
  const [reportsLoading, setReportsLoading] = useState(false);
  const [reports, setReports] = useState(null);
  const appService = new AppService();

  const getInitialSidebarState = () => {
    if (typeof window !== "undefined") {
      const saved = localStorage.getItem("sidebarOpen");
      if (saved !== null) {
        return JSON.parse(saved);
      }
      return window.innerWidth >= 768; // Default open for desktop
    }
    return true; // Safe default for SSR
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(getInitialSidebarState);

  const getReports = async (payload: any) => {
    try {
      setReportsLoading(true);
      const baseAuthUrl = process.env.REACT_APP_BASE_URL || "";
      const reports = await appService.getReports(baseAuthUrl, payload);
      setReports(reports);
    } catch (error) {
      console.log(error);
    } finally {
      setReportsLoading(false);
    }
  };

  return {
    t,
    isSidebarOpen,
    setIsSidebarOpen,
    getReports,
    reports,
    reportsLoading,
  };
};
